import UpdateProgram from "pages/dashboard/shared/UpdateProgram/UpdateProgram";
import { FC } from "react";

interface AdminProgramUpdateProps {}

const AdminProgramUpdate: FC<AdminProgramUpdateProps> = () => {
  return <UpdateProgram />;
};
export default AdminProgramUpdate;
